import React from 'react';
import { CommonDeleteModal } from 'components';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  dataToDelete: Record<string, any> | undefined;
  onDeleteModalClose: (id?: string) => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={() => onDeleteModalClose()}
        open={openModal}
        isLoading={isLoading}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={() => onDeleteModalClose()}
        title={'Delete Role'}
        message={
          'Deleting the Role will also remove it from all the Users to which it is assigned and they will lose permissions associated with it. Are you sure you want to delete the Role?'
        }
      />
    </>
  );
};
